import SFetch from '@app/utils/sfetch'

export default {
  // We extended this API call to optionally receive companyId, sometimes we want to make this call but currentCompanyid is not available on global variable(e.g.firm inbox).
  postComment(
    commentableId,
    commentableType,
    params,
    currentCompanyId = Silverfin.currentCompanyId
  ) {
    const url = Silverfin.Routes.comments_path(
      Silverfin.currentFirmId,
      currentCompanyId,
      { format: 'json' }
    )
    return SFetch.json(url, {
      method: 'POST',
      body: {
        comment: params,
        commentableId,
        commentableType,
      },
    })
  },

  // We extended this API call to optionally receive companyId, sometimes we want to make this call but currentCompanyid is not available on global variable(e.g.firm inbox).
  editComment(
    commentableId,
    commentableType,
    id,
    params,
    currentCompanyId = Silverfin.currentCompanyId
  ) {
    const url = Silverfin.Routes.comment_path(
      Silverfin.currentFirmId,
      currentCompanyId,
      id,
      { format: 'json' }
    )

    return SFetch.json(url, {
      method: 'PATCH',
      body: { comment: params, commentableId, commentableType },
    })
  },

  destroyComment(
    id,
    currentCompanyId = Silverfin.currentCompanyId,
    commentableType,
    commentableId
  ) {
    const url = Silverfin.Routes.comment_path(
      Silverfin.currentFirmId,
      currentCompanyId,
      id,
      {
        format: 'json',
        commentable_type: commentableType,
        commentable_id: commentableId,
      }
    )
    return SFetch.jsonWithAlert(url, {
      method: 'DELETE',
    })
  },
}
